import { FC } from 'react'
import { SvgProps } from './svgProps'

const RattingColorIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    width={width || 20}
    height={height || 20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 10C0.5 15.2467 4.75329 19.5 10 19.5V0.5C4.75329 0.5 0.5 4.75329 0.5 10Z"
      fill={color || '#000'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0.5C9.83228 0.5 9.66558 0.504346 9.5 0.512932C4.48572 0.772939 0.5 4.92101 0.5 10C0.5 15.079 4.48572 19.2271 9.5 19.4871C9.66558 19.4957 9.83228 19.5 10 19.5C10.1677 19.5 10.3344 19.4957 10.5 19.4871C15.5143 19.2271 19.5 15.079 19.5 10C19.5 4.92101 15.5143 0.772939 10.5 0.512932C10.3344 0.504346 10.1677 0.5 10 0.5ZM9.5 1.51446C5.03831 1.77327 1.5 5.47343 1.5 10C1.5 14.5266 5.03831 18.2267 9.5 18.4855V1.51446ZM10.5 18.4855V1.51446C14.9617 1.77327 18.5 5.47343 18.5 10C18.5 14.5266 14.9617 18.2267 10.5 18.4855Z"
      fill={color || '#000'}
    />
  </svg>
)

export default RattingColorIcon
